



































































































































import Vue from "vue";
import router from '../router';

export default Vue.extend({
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
    };
  },
  computed: {
    lohnnebenkosten(): string {
      return (
        "zzgl. " +
        ((this.$store.state.personalkostensatzOhneLohnnebenkosten ?? 0) * 0.35).toFixed(2) +
        " € Lohnnebenkosten (geschätzt)"
      );
    }
  },
  methods: {
    updatePersonalkostenquote(event:any) {
      let value = parseFloat(event.srcElement.value);
      if (!value || isNaN(value)) {
        value = 0;
      }
      this.$store.commit("updatePersonalkostenquote", value);
    },
    updatePersonalkostensatz(event:any) {
      let value = parseFloat(event.srcElement.value);
      if (!value || isNaN(value)) {
        value = 0;
      }
      this.$store.commit("updatePersonalkostensatz", value * 1.35);
      this.$store.commit("updatePersonalkostensatzOhneLohnnebenkosten", value);
    },
    updateUmsatzProGast(event:any) {
      let value = parseFloat(event.srcElement.value);
      if (!value || isNaN(value)) {
        value = 0;
      }
      this.$store.commit("updateUmsatzProGast", value);
    },
    updateGastVerweildauer(event:any) {
      let value = parseFloat(event.srcElement.value);
      if (!value || isNaN(value)) {
        value = 0;
      }
      this.$store.commit("updateGastVerweildauer", value);
    },
    handleClose(removedTag:string) {
      this.$store.commit("removeGroup", removedTag);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        (this.$refs.input as any).focus();
      });
    },
    handleInputChange(e:any) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      if(this.inputValue && this.inputValue != "") {
        this.$store.commit("addGroup", this.inputValue);
        this.inputVisible = false;
        this.inputValue = "";
      }
    },
    onNextClick: function() {
      this.form.validateFields((err) => {
        if (!err) {
          router.push("umsatzplanung");
        }
      });
    }
  }
});
